import React from 'react';
import {Modal} from "antd";
import {ReactComponent as NewIcon} from '../../../../../../../../assets/calendar/new.svg';
import {ReactComponent as FinishedIcon} from '../../../../../../../../assets/calendar/finished.svg';
import {ReactComponent as ProblemsIcon} from '../../../../../../../../assets/calendar/problems.svg';
import {ReactComponent as InProgressIcon} from '../../../../../../../../assets/calendar/inProgress.svg';
import {Link, useParams} from "react-router-dom";


interface IEvent {
    end: Date;
    endFormatted: string;
    hasProblem: boolean;
    id: number;
    problems: {
        absenceOfStudents: boolean;
        technicalProblems: boolean;
        lateCancellation: boolean;
        other: boolean;
        comment: boolean;
    };
    start: Date;
    startFormatted: string;
    status: string;
    title: string;
}


interface ICustomModal {
    selectedEvents: IEvent[];
    formattedDate: string;
    isModalOpen: boolean;
    handleOk: () => void;
    handleCancel: () => void;
}

export const CustomModal: React.FC<ICustomModal> = (
    {selectedEvents, formattedDate, isModalOpen, handleOk, handleCancel}
) => {
    const {groupId} = useParams();
    return (
        <Modal
            className='myUniqueModal'
            title={
                selectedEvents.length > 0 ? (
                    <div className='calendar-modal-title'>
                        <span className='calendar-modal-header'>{formattedDate.split(' ').slice(0, 3).join(' ')}</span>
                        <span className='calendar-modal-weekday'>{formattedDate.split(' ')[3]}</span>
                    </div>
                ) : (
                    ''
                )
            }
            visible={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
        >
            {selectedEvents.length > 0 ? (
                selectedEvents.map((event) => (
                    <React.Fragment key={event.id}>
                        <div className='calendar-modal-body'>
                            {(event.status === 'finished' && event.hasProblem) ? (
                                <div className='body-left finished-time-problems'>
                                    <span className='body-left-icon'>
                                        <ProblemsIcon/>
                                    </span>
                                    <span className='time'>
                                             {event.start.toLocaleTimeString([], {
                                                 hour: '2-digit',
                                                 minute: '2-digit',
                                             })}
                                    </span>
                                </div>

                            ) : null
                            }

                            {(event.status === 'new' && event.hasProblem) ? (
                                <div className='body-left new-time-problems'>
                                    <span className='body-left-icon'>
                                        <ProblemsIcon/>
                                    </span>
                                    <span className='time '>
                                             {event.start.toLocaleTimeString([], {
                                                 hour: '2-digit',
                                                 minute: '2-digit',
                                             })}
                                    </span>
                                </div>

                            ) : null
                            }

                            {(event.status === 'new' && !event.hasProblem) ? (
                                <div className='body-left new-time'>
                                    <NewIcon/>
                                    <span className='time '>
                                             {event.start.toLocaleTimeString([], {
                                                 hour: '2-digit',
                                                 minute: '2-digit',
                                             })}
                                    </span>
                                </div>

                            ) : null
                            }

                            {(event.status === 'finished' && !event?.hasProblem) ? (
                                <div className='body-left finished-time'>
                                       <span className='body-left-icon'>
                                        <FinishedIcon/>
                                       </span>
                                    <span className='time'>
                                             {event.start.toLocaleTimeString([], {
                                                 hour: '2-digit',
                                                 minute: '2-digit',
                                             })}
                                    </span>
                                </div>
                            ) : null
                            }

                            {(event.status === 'inProgress' && !event?.hasProblem) ? (
                                <div className='body-left new-time'>
                                       <span className='body-left-icon'>
                                        <InProgressIcon/>
                                       </span>
                                    <span className='time'>
                                             {event.start.toLocaleTimeString([], {
                                                 hour: '2-digit',
                                                 minute: '2-digit',
                                             })}
                                    </span>
                                </div>

                            ) : null
                            }

                            {(event.status === 'inProgress' && event?.hasProblem) ? (
                                <div className='body-left new-time-problems'>
                                       <span className='body-left-icon'>
                                        <InProgressIcon/>
                                       </span>
                                    <span className='time'>
                                             {event.start.toLocaleTimeString([], {
                                                 hour: '2-digit',
                                                 minute: '2-digit',
                                             })}
                                    </span>
                                </div>

                            ) : null
                            }


                            <div className='body-right'>
                                <Link
                                    className={`body-right-title ${event.hasProblem ? 'problems' : 'not-problems'}`}
                                    to={`/groups/${groupId}/lessons/${event.id}`}
                                >
                                    {event.title}
                                </Link>
                                {event?.problems && (
                                    <div
                                        className={`body-right-problems ${event.hasProblem ? 'problem' : ''}`}>
                                        {event?.problems?.absenceOfStudents &&
                                            <span className='right-problems'>Отсутствие студента</span>}
                                        {event?.problems?.technicalProblems &&
                                            <span className='right-problems'>Технические проблемы</span>}
                                        {event?.problems?.comment &&
                                            <span className='right-problems'>Комментарий к проблеме</span>}
                                        {event?.problems?.lateCancellation &&
                                            <span className='right-problems'>Поздняя отмена</span>}
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr className='calendar-hr'/>
                    </React.Fragment>
                ))
            ) : (
                <p>Loading...</p>
            )}
        </Modal>
    );
};


